<script setup>
//#region props
const props = defineProps({
  disabled: {
    type: Boolean,
    default: () => false,
  },
  statusType: {
    type: String,
    default: () => '',
  },
  statusText: {
    type: String,
    default: () => '',
  },
  activeValue: {
    type: [String, Boolean, Number],
    default: () => true,
  },
  inactiveValue: {
    type: [String, Boolean, Number],
    default: () => false,
  },

});
//#endregion

const emit = defineEmits(['change']);

const modelValue = defineModel({ type: [Boolean, String, Number] });

</script>
<template>
  <div class="ui-switch">
    <UiStatusText
      v-if="statusType"
      :type="statusType"
      :text="statusText"
      class="t:mr-8"
    />
    <ElSwitch
      v-model="modelValue"
      class="ui-switch__switch"
      :disabled="disabled"
      :active-value="activeValue"
      :inactive-value="inactiveValue"
      @change="emit('change', modelValue)"
    />
  </div>
</template>

<style lang="scss">
.ui-switch{
  line-height: 1;
  &__switch {
    height: auto;
    --el-switch-off-color: var(--background-negative);
    --el-switch-on-color: var(--background-positive);
  }
}
</style>
